export const BNB_FEE_FRACTION = 0.00045; // TODO calculate or get fee in counter currency from API

export function sumBotInstanceOpenProfit(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.tradeList;
  return trades && trades.length
    ? trades.map(t => (t.state !== "PENDING_OPEN" ? getActualPotentialProfitOfTrade(t) : 0)).reduce((a, b) => a + b, 0)
    : null;

  // const openOpenTotal = sumBotInstanceOpenTradesOpenTotal(botInstance);
  // const openPredictedTotal = sumBotInstanceOpenTradesPredictedTotal(botInstance);
  // const openCloseTotal = sumBotInstanceOpenTradesCloseTotal(botInstance);
  // return openPredictedTotal && openOpenTotal && openPredictedTotal - openOpenTotal + (openCloseTotal || 0);
}

export function sumBotInstanceMoneyUsedInOpenTrades(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.tradeList;
  return trades && trades.length
    ? trades
        .map(t => {
          const tradeOpenTotal = sumXTradesTotal(t.openXTradeList.filter(t => t.state !== "PENDING_OPEN"));
          return t.leverage ? tradeOpenTotal / t.leverage : tradeOpenTotal;
        })
        .reduce((a, b) => a + b, 0)
    : null;
}

export function sumBotInstanceOpenTradesCloseTotal(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.tradeList;
  return trades && trades.length
    ? trades.map(t => sumXTradesTotal(t.closeXTradeList)).reduce((a, b) => a + b, 0)
    : null;
}

export function sumBotInstanceOpenTradesPredictedTotal(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.tradeList;
  return trades && trades.length
    ? trades
        .filter(t => t.state !== "PENDING_OPEN")
        .map(t => (t.currentMarketBid || 0) * t.openTradedAmount)
        .reduce((a, b) => a + b, 0)
    : null;
}

export function sumBotInstanceClosedTradesOpenTotal(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.closedTradeList;
  return trades && trades.length ? trades.map(t => sumXTradesTotal(t.openXTradeList)).reduce((a, b) => a + b, 0) : null;
}

export function sumBotInstanceClosedTradesCloseTotal(botInstance) {
  const state = getBotState(botInstance);
  const trades = state.closedTradeList;
  return trades && trades.length
    ? trades.map(t => sumXTradesTotal(t.closeXTradeList)).reduce((a, b) => a + b, 0)
    : null;
}

// export function sumBotInstanceClosedTradesCloseFee(botInstance) {
//   const state = getBotState(botInstance);
//   const trades = state.closedTradeList;
//   return trades && trades.length ? trades.map(t => sumXTradesFee(t.closeXTradeList)).reduce((a, b) => a + b, 0) : null;
// }

export function getBotState(botInstance) {
  if (typeof botInstance.state === "string") {
    botInstance.state = JSON.parse(botInstance.state);
  }
  return botInstance.state || {};
}

export function getBotConfig(botInstance) {
  if (typeof botInstance.config === "string") {
    botInstance.config = JSON.parse(botInstance.config);
  }
  return botInstance.config || {};
}

export function sumXTradesTotal(xTrades) {
  return xTrades && xTrades.length ? xTrades.map(xt => xt.totalPrice).reduce((a, b) => a + b, 0) : null;
}

export function sumXTradesFee(xTrades) {
  return xTrades && xTrades.length
    ? xTrades
        .map(xt => (xt.feeCurrencyCode === "BNB" ? xt.totalPrice * BNB_FEE_FRACTION : xt.feeTotal))
        .reduce((a, b) => a + b, 0)
    : null;
}

export function revertIfShorting(shorting, val) {
  const result = shorting ? val * -1 : val;
  return result;
}

/**
 * Returns fee %/100 to be able to directly multiply this value with priceTotal to get totalFee
 * Vaues for Binance:
 * https://www.binance.com/en/blog/futures/trade-crypto-futures-how-much-does-it-cost-421499824684902239
 */
export function getDefaultCloseFeeEstimationForCcyPair(ccyPairString) {
  if (ccyPairString === "BTCBUSD") {
    return 0.000207; //BTCBUSD default taker fee for VIP0 (with 10% discount for BNB): 0.0207% = 0.000207
  } else if (ccyPairString === "BTCUSDT") {
    return 0.00036; //BTCUSDT default taker fee for VIP0 (with 10% discount for BNB): 0.0360% = 0.000360
  } else {
    console.warn("Default close fee for ccyPair " + ccyPairString + " not provided. 0 is used as fee estimation.");
    return 0;
  }
}

export function sumXTradesAmount(xTrades) {
  return xTrades && xTrades.length ? xTrades.map(xt => xt.amount).reduce((a, b) => a + b, 0) : null;
}

export function sumXTradesPNL(xTrades) {
  return xTrades && xTrades.length ? xTrades.map(xt => xt.realizedPnl).reduce((a, b) => a + b, 0) : null;
}

export function parseCurrencyPairString(currencyPairString) {
  const currencyPairArr = currencyPairString.split("/");
  return {
    base: currencyPairArr[0],
    counter: currencyPairArr[1],
  };
}

export function findUsedSuspiciousCcys(botInstance, suspiciousCurrencies) {
  const { supportedCurrencyPairs, excludedCurrencyPairs } = botInstance.config;

  const usedCcys = (supportedCurrencyPairs || [])
    .filter(ccy => excludedCurrencyPairs && excludedCurrencyPairs.indexOf(ccy) === -1)
    .reduce((acc, ccyPair) => {
      const parsedCcyPair = parseCurrencyPairString(ccyPair);
      acc.add(parsedCcyPair.base);
      acc.add(parsedCcyPair.counter);

      return acc;
    }, new Set());

  return suspiciousCurrencies.filter(ccy => usedCcys.has(ccy));
}

export function getActualPotentialProfitOfTrade(trade) {
  const closedState = trade.state === "CLOSED";
  const currencyPair = trade.currencyPair;
  const baseCurrency = currencyPair.split("/")[0];
  const counterCurrency = currencyPair.split("/")[1];
  const ccyPairString = baseCurrency + counterCurrency;
  const futureTrade = !!trade.leverage;
  const shorting = trade.shorting;
  const actualPrice = shorting ? trade.currentMarketAsk : trade.currentMarketBid;

  const openTotal = sumXTradesTotal(trade.openXTradeList);
  const closeTotal = sumXTradesTotal(trade.closeXTradeList);
  const openAmount = sumXTradesAmount(trade.openXTradeList);
  const closeAmount = sumXTradesAmount(trade.closeXTradeList);
  const unclosedAmount = closedState ? 0 : openAmount - closeAmount;

  let closeFee = 0;
  let openFee = 0;
  let otherFees = 0;
  let unclosedCloseFee = 0;

  if (futureTrade) {
    openFee = trade.openFeeTotal;
    closeFee = trade.closeFeeTotal;
    otherFees = trade.otherFees; //0 for not closed trade

    //If there is still some unclosed part, add to close fee also estimated fee according hardcoded fee values
    if (unclosedAmount > 0) {
      const unclosedTotal = actualPrice * unclosedAmount;
      unclosedCloseFee = getDefaultCloseFeeEstimationForCcyPair(ccyPairString) * unclosedTotal;
      //otherFees are not counted at all for not closed trades. It is needed to calcualte them on server side.
    }
  } else {
    //BRUTUS or old SPOT bots
    //Open fee is direclty subtracted from open amount so only close fee is relevant fro SPOT bots
    closeFee = sumXTradesFee(trade.closeXTradeList);
  }

  let profit;
  if (futureTrade) {
    profit = sumXTradesPNL(trade.closeXTradeList) - openFee - closeFee + otherFees; //Same as in Trade.calculateProfitTotal()

    if (!closedState) {
      profit = profit - unclosedCloseFee; //Include estimated close fee to profit

      //Add potential profit if actual price is used for close
      const unclosedTotal = unclosedAmount * actualPrice;
      const correspondingPartFromOpenTotal = unclosedAmount / openAmount * openTotal;
      let potentialProfitFromUnclosedPart = unclosedTotal - correspondingPartFromOpenTotal;
      if (shorting) {
        potentialProfitFromUnclosedPart = potentialProfitFromUnclosedPart * -1;
      }
      profit = profit + potentialProfitFromUnclosedPart;
    }
  } else {
    //Old SPOT implementation
    profit = closeTotal !== null && closeTotal - openTotal - closeFee;
  }

  return profit;
}



// WEBPACK FOOTER //
// ./src/utils/botUtils.js